export const POLITICAL_AFFILIATION = [
  { value: "ANY", label: "All" },
  { value: "Republican", label: "Republican" },
  { value: "Democrat", label: "Democrat" },
  { value: "Independent", label: "Independent" },
  { value: "Libertarian", label: "Libertarian" },
  { value: "Green Party", label: "Green Party" },
  { value: "Conservative", label: "Conservative" },
  { value: "Liberal", label: "Liberal" },
  { value: "Moderate", label: "Moderate" },
  { value: "Progressive", label: "Progressive" },
  { value: "Apolitical", label: "Apolitical" },
  { value: "Other", label: "Other" },
  { value: "Prefer not to say", label: "Prefer not to say" },
];
